import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, takeUntil } from 'rxjs';
import { ThemesService } from './services/themes.service';
import { UsersService } from './services/users.service';
import { RouterOutlet } from '@angular/router';
import { NavMenuComponent } from './components/core/nav-menu/nav-menu.component';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { NavTopBarComponent } from './components/core/nav-top-bar/nav-top-bar.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NavTopBarComponent, MatSidenavContainer, MatSidenav, NavMenuComponent, RouterOutlet, NgxSpinnerModule]
})
export class AppComponent implements OnInit, OnDestroy {
    private destroyRef = inject(DestroyRef);

    title = 'app';
    showNav = false;
    showMenu = true;

    public currentUserSubscription: Subscription;

    constructor(private usersService: UsersService, private translateService: TranslateService, private themesService: ThemesService) {}

    ngOnInit() {
        this.themesService.changeTheme(this.themesService.getCurrentTheme());
        const currentLang = sessionStorage.getItem('language');

        if (!!currentLang) {
            this.translateService.setDefaultLang(currentLang);
            this.translateService.use(currentLang);
        } else {
            let browserLanguage = this.translateService.getBrowserCultureLang();

            // Les navigateurs ne retournant pas les mêmes valeurs (ex français: Chrome fr-FR, Firefox fr)
            // utilisation seulement des 2 premières lettres
            browserLanguage = browserLanguage.substring(0, 2);

            this.translateService.setDefaultLang(browserLanguage);
            this.translateService.use(browserLanguage);
        }

        this.currentUserSubscription = this.usersService.currentUser.subscribe({
            next: (user) => {
                if (!!user) {
                    this.showNav = true;
                } else {
                    this.showNav = false;
                }
            },
            error: () => {
                this.showNav = false;
            },
        });
    }

    onShowMenu(MenuShowed: boolean) {
        this.showMenu = MenuShowed;
    }

    ngOnDestroy() {
        if (this.currentUserSubscription) {
            this.currentUserSubscription.unsubscribe();
        }
    }
}
